module.exports = __webpack_public_path__ + "static/media/icon-phone.1742a464.svg";